export function dayCellsDate(cells) {
  return cells.days[0].dataset.date
}
